import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { t } from '../utils/i18n';

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(() => window.FancianAppearance?.getTheme() || 'dark');
  useEffect(() => {
    const sync = () => setTheme(window.FancianAppearance?.getTheme() || 'dark');
    window.addEventListener('fancian-appearance-change', sync);
    return () => window.removeEventListener('fancian-appearance-change', sync);
  }, []);
  const next = theme === 'dark' ? 'light' : 'dark';
  return <button type="button" className="admin-theme-switch" onClick={() => window.FancianAppearance?.setTheme(next)} aria-label={t(`adminUi.themeTo${next === 'light' ? 'Light' : 'Dark'}`)}>
    {theme === 'dark' ? <Sun size={17} aria-hidden="true" /> : <Moon size={17} aria-hidden="true" />}
    <span>{t(`adminUi.${theme}Theme`)}</span>
  </button>;
}
